module.exports = "h2{font-size:18px}\n"